var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('cover-image'),_c('profile-image'),_c('div',{attrs:{"id":"button"},on:{"click":_vm.forward}},[_vm._v("Next")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }